import React from "react";
import Modal from "Components/smallModal/smallModal";
import Input from "Components/input/Input";
import Button from "Components/button/Button";
import PasswordGenerator from "Components/PasswordGenerator";

import t from "Utils/translation";
import s from "./changePasswordModal.scss";

class ChangePasswordModal extends React.Component {
  state = {};

  fillPasswordFields = (generatedPassword) => {
    this.props.setFormFieldValue({
      password: generatedPassword,
      password_confirmation: generatedPassword,
    });
  };

  onChange = (val) => {
    const key = Object.keys(val)[0];

    if (key === "new_password") {
      this.props.setFormFieldValue({ password: val[key] });
    }

    if (key === "new_password_confirmation") {
      this.props.setFormFieldValue({ password_confirmation: val[key] });
    }

    if (key === "password") {
      this.props.setFormFieldValue({ password_current: val[key] });
    }
  };

  render() {
    const {
      opened,
      handleResetPassword,
      handleClose,
      formData,
      setFormFieldValue,
      formErrors,
      isFormLoading,
      passwordExpired,
      confirmSelfPassword,
    } = this.props;

    return (
      <Modal
        title={passwordExpired ? t("modal.change.passwordExpired.title") : t("modal.change.password.title")}
        opened={opened}
        closeModal={handleClose}
        withForm
      >
        <form className={s.form} onSubmit={handleResetPassword}>
          <div className={s.wrapInputs}>
            {confirmSelfPassword && (
              <Input
                className={s.input}
                name="password"
                label={t("input.label.password.old")}
                placeholder={t("input.placeholder.password")}
                type="password"
                onChange={this.onChange}
                value={formData.password_current}
                errors={formErrors.password_current}
                required
              />
            )}

            <Input
              className={s.input}
              name="new_password"
              label={t("input.label.password.new")}
              type="password"
              onChange={this.onChange}
              value={formData.password}
              errors={formErrors.password}
              required
              showPasswordScore
            />

            <Input
              className={s.input}
              name="new_password_confirmation"
              label={t("input.label.passwordConfirm.new")}
              type="password"
              onChange={this.onChange}
              value={formData.password_confirmation}
              errors={formErrors.password_confirmation}
              required
            />

            <PasswordGenerator onNewPassword={this.fillPasswordFields} />
          </div>
          <div className={s.footerBtn}>
            {!this.props.passwordExpired && (
              <Button color="text" onClick={handleClose}>
                button.cancel
              </Button>
            )}

            <Button type="submit" loading={isFormLoading}>
              button.save
            </Button>
          </div>
        </form>
      </Modal>
    );
  }
}

export default ChangePasswordModal;
